import React from 'react';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Checkbox, TableHead, TableRow } from '@mui/material';
import * as S from '../../styles';

interface TableHeaderProps {
  headers: [string, string][];
  hidingColumn: string | null;
  hidingColumns: Set<string>;
  showingColumns: Set<string>;
  onHideColumn: (columnKey: string) => void;
  numSelected: number;
  rowCount: number;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  headers,
  hidingColumn,
  hidingColumns,
  showingColumns,
  onHideColumn,
  numSelected,
  rowCount,
  onSelectAllClick,
}) => (
  <TableHead>
    <TableRow>
      <S.StickyCheckboxCell>
        <Checkbox
          color='primary'
          size='small'
          indeterminate={numSelected > 0 && numSelected < rowCount}
          checked={rowCount > 0 && numSelected === rowCount}
          onChange={onSelectAllClick}
          inputProps={{
            'aria-label': 'Select all records',
          }}
        />
      </S.StickyCheckboxCell>
      {headers.map(([key, label], index) => {
        const canHide = true;
        const isHiding = hidingColumn === key || hidingColumns.has(key);
        const isShowing = showingColumns.has(key);

        return (
          <S.HoverableTableHeadCell
            key={key}
            data-column={key}
            data-column-index={index + 1}
            $canHide={canHide}
            $isHiding={isHiding}
            $isShowing={isShowing}
          >
            {label}
            {canHide && (
              <S.HideColumnIcon
                onClick={(e) => {
                  e.stopPropagation();
                  onHideColumn(key);
                }}
              >
                <VisibilityOffIcon />
              </S.HideColumnIcon>
            )}
          </S.HoverableTableHeadCell>
        );
      })}
    </TableRow>
  </TableHead>
);
